// assets
import { Teacher } from 'iconsax-reactjs';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS - ASSESSORS ||============================== //

const Assessors: NavItemType = {
  id: 'group-assessors',
  title: 'Assessors',
  type: 'group',
  visibleForUserTypes: ['assessorAdmin'],
  children: [
    {
      id: 'assessors',
      title: 'Assessors',
      type: 'item',
      url: '/assessors',
      icon: Teacher,
      breadcrumbs: false
    }
  ]
};

export default Assessors;
